export function routeForStartParameter(startParameter: string | null): string | null {
  if (!startParameter) return null;
  if (startParameter === 'vip_free_5') return '/?pass=open&campaign=vip_free_5_v1';
  if (startParameter === 'chat') return '/chat?tab=global';
  if (/^chat_[0-9a-f-]{36}$/i.test(startParameter))
    return `/chat?tab=private&conversation=${startParameter.slice(5)}`;
  if (startParameter === 'shop_pass') return '/?pass=open&campaign=pass_progress_v1';
  if (startParameter === 'shop_pass_interest') return '/?pass=open&campaign=product_interest_v1';
  if (startParameter === 'shop_artifacts')
    return '/store?view=artifacts&campaign=product_interest_v1';
  if (startParameter === 'shop_offers') return '/store?offers=preferences';
  if (startParameter === 'shop_discover') return '/store?view=discover&campaign=bot_launch_v1';
  if (startParameter === 'shop_checkout') return '/store?campaign=checkout_return_v1';
  if (startParameter === 'shop_interest') return '/store?campaign=product_interest_v1';
  const nurtureGems = /^shop_gems_([1345])$/.exec(startParameter);
  if (nurtureGems) return `/store?view=discover&campaign=diamond_nurture_${nurtureGems[1]}_v1`;
  if (startParameter === 'shop_artifacts_2')
    return '/store?view=artifacts&campaign=diamond_nurture_2_v1';
  if (/^pathl?_\d+$/.test(startParameter)) {
    const level = Number(startParameter.slice(startParameter.indexOf('_') + 1));
    if (level < 1) return '/path';
    return startParameter.startsWith('pathl_') ? `/path/game/${level}` : `/path?focus=${level}`;
  }
  if (startParameter.startsWith('dueltv_')) return `/duel/${startParameter.slice(7)}/tv`;
  if (startParameter === 'duels_mine') return '/duels?tab=mine';
  if (startParameter.startsWith('duel_')) return `/duel/${startParameter.slice(5)}`;
  if (startParameter.startsWith('club_')) return `/club/invite/${startParameter.slice(5)}`;
  if (startParameter.startsWith('profile_')) return `/profile/${startParameter.slice(8)}`;
  if (startParameter.startsWith('clubchat_')) return `/club/${startParameter.slice(9)}?tab=chat`;
  if (/^payment_[0-9a-f-]{36}$/i.test(startParameter))
    return `/store?payment=${startParameter.slice(8)}`;
  return (
    {
      clubs: '/club',
      play: '/game/daily',
      leaders: '/leaders',
      duels: '/duels',
      store: '/store',
      profile: '/profile',
    }[startParameter] ?? null
  );
}

interface StartRouteStorage {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
}

const consumedLaunchKey = 'bb_consumed_start_launch';

export function consumeStartRoute(
  platform: 'vk' | 'max' | 'web',
  rawLaunchData: string,
  startParameter: string | null,
  storage: StartRouteStorage,
): string | null {
  const route = routeForStartParameter(startParameter);
  if (!route || !startParameter) return null;
  const launch = new URLSearchParams(rawLaunchData);
  const launchIdentity =
    launch.get('hash') ??
    launch.get('sign') ??
    launch.get('auth_date') ??
    launch.get('vk_ts') ??
    rawLaunchData.slice(-128);
  const marker = `${platform}:${startParameter}:${launchIdentity}`;
  try {
    if (storage.getItem(consumedLaunchKey) === marker) return null;
    storage.setItem(consumedLaunchKey, marker);
  } catch {
    // Some embedded browsers can deny session storage. Navigation must still work once.
  }
  return route;
}
